import { getSessionIdentity, bearerHeaders } from '../auth/descope';

export default id => (dispatch) => {
  const auth = getSessionIdentity();
  if (!auth.email) {
    return;
  }

  dispatch({ type: 'DELETE_PORTFOLIO', id, pending: true });

  const body = {
    sedol: null,
    isin: null,
    cusip: null,
    clientEmail: auth.email,
    isDeleted: true,
  };

  fetch(`${process.env.REACT_APP_DPD_URL}/api/portfolio/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      ...bearerHeaders(auth),
    },
  })
    .then(d => d.json())
    .then(data => {
      dispatch({ type: 'DELETE_PORTFOLIO', id });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'DELETE_PORTFOLIO', id, pending: false });
    });
};
